import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const intent = window.localStorage.getItem("signup_intent");
        window.localStorage.removeItem("signup_intent");
        const { data } = await api.post("/auth/session", {
          session_id: sid,
          party_type: intent || undefined,
        });
        // CRITICAL: push the freshly authenticated user into AuthContext so
        // ProtectedRoute sees user != null on the very next render. Without this
        // it bounces back to /login because the AuthProvider's mount-time
        // /auth/me probe was skipped while the session_id hash was present.
        setUser(data.user);
        // strip fragment
        window.history.replaceState(null, "", window.location.pathname);
        if (data.user.role === "admin") navigate("/admin", { replace: true });
        else if (data.user.party_type === "seller") navigate("/dashboard/supplier", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-parchment">
      <div className="text-center">
        <div className="overline mb-3">Authenticating</div>
        <div className="h-serif text-3xl text-ink">Verifying your credentials…</div>
        {error && <div className="mt-4 text-danger" data-testid="auth-error">{error}</div>}
      </div>
    </div>
  );
}
